import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

document.addEventListener('DOMContentLoaded', function() {
	const excTypeformElement = document.querySelector('#exc-typeform');
	tippy('[data-tippy-content]');

	if (excTypeformElement) {
		const widget = createWidget('AzahpB4t', {
			container: excTypeformElement,
			onSubmit: function(response) {
				const responseId = response.responseId; // Get the response ID
				const redirectUrl = `${window.location.origin}/cvm-benchmark-results?responseId=${responseId}`;

				setTimeout(() => {
					window.location.href = redirectUrl;
				}, 1200);
			},
		});
	}
});
